import approve from 'approvejs';
const COMPONENT_ERROR = 'COMPONENT_ERROR';

export function setComponentError(field, msg, prepareErrorMsgHandler) {
    if (!field) {
        return;
    }

    if (msg) {
        if (!field.rules){
            field.rules = {};
        }

        let rule = field.rules[COMPONENT_ERROR];
        if (!rule){
            field.rules[COMPONENT_ERROR] = rule = {};
        }

        if (prepareErrorMsgHandler) {
            msg = prepareErrorMsgHandler(msg);
        }

        rule.message = msg;
    } else {
        if (field.rules && field.rules[COMPONENT_ERROR]){
            field.rules[COMPONENT_ERROR].message = '';
        }
    }
}

const componentErrorTest = {
    expects: ['message'],
    message: 'Error',
    validate: (value, pairs) => {
        if (pairs.message) {
            console.log(pairs.message);
        }
        return !pairs.message;
    }
}

approve.addTest(componentErrorTest, COMPONENT_ERROR);


// WEBPACK FOOTER //
// ./src/utils/component_error_rule.js